import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { ISubmissionStatus } from '@/shared/model/submission-status.model';

const baseApiUrl = 'api/submission-statuses';

export default class SubmissionStatusService {
  public find(id: number): Promise<ISubmissionStatus> {
    return new Promise<ISubmissionStatus>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    // bugfix: size to 75 or dosent retrieve all elemenet; if there will same problems increase size
    if (!paginationQuery) {
      paginationQuery = {
        page: 0,
        size: 75,
        sort: ['id', 'asc']
      };
    }
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: ISubmissionStatus): Promise<ISubmissionStatus> {
    return new Promise<ISubmissionStatus>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ISubmissionStatus): Promise<ISubmissionStatus> {
    return new Promise<ISubmissionStatus>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
